import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import {
    IconButton,
    InputAdornment,
    Dialog,
    Grid,
    Button
} from '@material-ui/core';
import * as logger from '../../../logger';
import RightSideBar from '../../components/RightSideBar/RightSideBar';
import HttpsIcon from '@material-ui/icons/Https';
import { JourneyTripBilty, StaticStatusIcon } from '../../../components/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { simTrackingRegister, getLocationForSimTracking } from '../../../store/actions/vehicleActionCreator';
import { getTripDetailsV3,getJourneyDetails } from '../../../store/actions/tripActionCreator';
import Timer from 'react-compound-timer'
import TimerIcon from '@material-ui/icons/Timer';
import MapComponent from '../../components/MapComponent/MapComponent';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { getDatePickerDateInStringDDMMMYYYY,getTimeInHHMM } from '../../../utils/utils';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import { updateChatView } from '../../../store/actions/userActionCreators';
const useStyles = makeStyles((theme) => ({
    divBox: {
        backgroundColor: '#f1f1f3',
        padding: 16,
        borderRadius: 8,
        marginBottom: 8,
    },
    divBoxV1: {
        backgroundColor: '#f1f1f3',
        padding: 16,
        borderRadius: 8,
        marginBottom: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    vehicleNumberV1: {
        fontWeight: 300,
        '&:last-child': {
            color: '#0033cc',
            marginLeft: 4
        }
    },
    titleV1: {
        color: 'grey',
        letterSpacing: '0.03em',
        fontSize: 12
    },
    titleV2: {
        color: 'grey',
        letterSpacing: '0.03em',
        fontSize: 10,
        marginTop: 3
    },
    sep: {
        display: "inline-block",
        margin: "0 4px",
        fontSize:10,
        color: "lightgrey"
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(1.8)",
        color: "#0033cc"
    },
    bulletV1: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.7)",
        color: "darkgrey"
    },
    fsV1: {
        fontSize: 12
    },
    fwV1: {
        fontWeight: 300
    },
    mtV2: {
        marginTop: 8,
        fontWeight: 300
    },
    mtV1: {
        marginTop: 16
    },
    colorV2: {
        color: 'darkgrey'
    },
    colorV1: {
        color: '#0033cc'
    },
    divV3: {
        display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 16
    },
    divV1: {
        textAlign: 'center'
    },
    divStatic: {
        backgroundColor: '#e86825',
        color: 'white',
        fontSize: 13,
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        borderRadius: 8,
        marginBottom: 8
    },
    retryButton: {
        backgroundColor: 'white',
        color: '#e86825',
        borderRadius: 8,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 8,
        paddingBottom: 8,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    iconV1: {
        fontSize: '4em',
    },
    mlV1: {
        marginLeft: 8
    },
    divAccepted: {
        backgroundColor: '#008556',
        color: 'white',
        display: 'flex',
        fontWeight: 'bold',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 16,
        fontSize: 13,
        borderRadius: 8
    },
    doneIcon: {
        color: 'white'
    },
    locationButton: {
        borderRadius: 8,
        color: '#008556',
        backgroundColor: 'white',
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 6,
        paddingBottom: 6,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: 'white',
        }
    },
    textV1: {
        fontSize: 13,
        marginLeft: 8
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center'
    },
    divTimer: {
        color: '#e5446d', backgroundColor: 'white', borderRadius: 6, paddingTop: 12, paddingBottom: 12, paddingLeft: 12, paddingRight: 12, display: 'flex', alignItems: 'center'
    },
    mrV1: {
        marginRight: 5
    },
    iconV2: {
        color: 'grey', fontSize: 14
    },
    divTimerV1: {
        fontSize: '17px !important'
    }
}));

const CheckApprovalDialog = ({ open,dispatchChatView, onClose, user, staticValue, consentPendingValue, dispatchTripDetailsAction, dispatchSimTracking, dispatchGetSimTrackingLocation, locationPollingValue }) => {

    let submit;
    let timeNow = new Date();
    let history = useHistory();
    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];

    const classes = useStyles();

    const [dialogOpen, setDialogOpen] = useState(open);
    const [staticStatus, setStaticStatus] = useState(staticValue ? staticValue : false);
    const [consentPendingStatus, setConsentPendingStatus] = useState(consentPendingValue ? consentPendingValue : false);
    const [vehicleDetails, setVehicleDetails] = useState({});
    const [locationPollingStatus, setLocationPollingStatus] = useState(locationPollingValue ? locationPollingValue : false);

    let vehicleNumber = user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.vehicleNumArrayDweb ? user.singleTripData.vehicle.vehicleNumArrayDweb : [];
    let vehicleBodyType = user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.vehicleBodyType ? user.singleTripData.vehicle.vehicleBodyType : ""
    let vehicle = user && user.singleTripData && user.singleTripData.vehicle ? user.singleTripData.vehicle : "";
    let journey = user && user.singleTripData && user.singleTripData.id ? user.singleTripData : null
    let tripId  = journey&&journey.trips&&journey.trips.length>0 && journey.trips[0] && journey.trips[0].id?journey.trips[0].id:''
    let journeyId = journey && journey.id ? journey.id : path[path.length - 1];
    let tripDetails  = journey&&journey.trips&&journey.trips.length>0 && journey.trips[0] && journey.trips[0].id?journey.trips[0]:null
    let lastTrip  = journey&&journey.trips&&journey.trips.length>0 && journey.trips[journey.trips.length-1] && journey.trips[journey.trips.length-1].id?journey.trips[journey.trips.length-1]:null
    let source = tripDetails&& tripDetails.startLocation ? tripDetails.startLocation : "";
    let destination = lastTrip && lastTrip.destinationLocation ? lastTrip.destinationLocation : "";
    let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

    useEffect(() => {
        setStaticStatus(staticValue);
        setConsentPendingStatus(consentPendingValue);
        setLocationPollingStatus(locationPollingValue)
    }, [staticValue, locationPollingValue, consentPendingValue])

    useEffect(() => {
        if (user.singleTripData && user.singleTripData.vehicle) {
            setVehicleDetails(user.singleTripData.vehicle);
        }
    }, [user.singleTripData])

    const onConfirm = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true)
    }

    const handleRetryClick = () => {

        let simData = {
            driverName: journey && journey.driver.driverName ? journey.driver.driverName : '',
            driverNumber: journey && journey.driver.driverContactNumber ? journey.driver.driverContactNumber : '',
            tripId: tripId,
        }

        dispatchSimTracking(
            simData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Driver Detail Dialog Dweb", "Updated driver details successfully");
                    dispatchTripDetailsAction(journeyId,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log('DriverDetails Dialog Dweb', 'Get Trip details successfull');
                                if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus == "consent_pending") {
                                    setConsentPendingStatus(true);
                                    setStaticStatus(false);
                                    setLocationPollingStatus(false);
                                } else if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus == "static") {
                                    setConsentPendingStatus(false);
                                    setStaticStatus(true);
                                    setLocationPollingStatus(false);
                                } else if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus == "location_polling") {
                                    if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.locationPoints && data.response.vehicle.locationPoints.length == 0) {
                                        setConsentPendingStatus(false);
                                        setStaticStatus(false);
                                        setLocationPollingStatus(true);
                                    } else if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.locationPoints && data.response.vehicle.locationPoints.length > 0) {
                                        setConsentPendingStatus(false);
                                        setStaticStatus(false);
                                        setLocationPollingStatus(false);
                                    }
                                }
                            }
                        },
                        () => {
                            logger.log('DriverDetails Dialog Dweb', 'Get Trip details failed');
                        }
                    );
                }
            }
        );
    }

    const handleTimerStop = () => {
        dispatchTripDetailsAction(journeyId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('DriverDetails Dialog Dweb', 'Get Trip details successfull');
                    if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus == "consent_pending") {
                        setConsentPendingStatus(true);
                        setStaticStatus(false);
                        setLocationPollingStatus(false);
                    } else if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus == "static") {
                        setConsentPendingStatus(false);
                        setStaticStatus(true);
                        setLocationPollingStatus(false);
                    } else if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.trackingStatus == "location_polling") {
                        if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.locationPoints && data.response.vehicle.locationPoints.length == 0) {
                            setConsentPendingStatus(false);
                            setStaticStatus(false);
                            setLocationPollingStatus(true);
                        } else if (data && data.response && data.response.vehicle && data.response.vehicle.tracking && data.response.vehicle.tracking.locationPoints && data.response.vehicle.locationPoints.length > 0) {
                            setConsentPendingStatus(false);
                            setStaticStatus(false);
                            setLocationPollingStatus(false);
                            history.push({
                                pathname: `/trips/sim-tracking-map/${journeyId}`,
                                // component: MapComponent,
                                state: {
                                    id: 1,
                                    pageTitle: journey && journey.driver && journey.driver.driverName ? journey.driver.driverName : "",
                                    sourceLocation: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
                                    destinationLocation: destination ?destination : ""
                                }
                            })
                        }
                    }
                }
            },
            () => {
                logger.log('DriverDetails Dialog Dweb', 'Get Trip details failed');
            }
        );
    }

    const handleGetLocationClick = () => {
        dispatchGetSimTrackingLocation(tripId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Check Approval Dweb", "Get Sim Tracking Location Successfull");
                    dispatchTripDetailsAction(journeyId,
                        (data) => {
                            logger.log("Check Approval Dweb", "Get Trip Details Successfull");
                            if (data && data.status && data.status.code == 200) {
                                history.push({
                                    pathname: `/trips/sim-tracking-map/${journeyId}`,
                                    component: MapComponent,
                                    state: {
                                        id: 1,
                                        pageTitle: journey && journey.driver && journey.driver.driverName ? journey.driver.driverName : "",
                                        sourceLocation: tripDetails && tripDetails.startLocation ? tripDetails.startLocation : "",
                                        destinationLocation: destination? destination : ""
                                    }
                                })
                            }

                        },
                        () => {
                            logger.log("Check Approval Dweb", "Get Trip Details Failed");
                        }
                    )
                }
            },
            () => {
                logger.log("Check Approval Dweb", "Get Sim Tracking Location Failed");
            }
        );

    }

    let seconds, minutes, hours, days, years;
    let secondsFinal, minutesFinal, hoursFinal, daysFinal, yearsFinal;

    //Calculating for nextretrytimestamp.
    if (vehicleDetails && vehicleDetails.tracking&& vehicleDetails.tracking.nextRetryTimestamp) {
        seconds = Math.abs(Number(Math.round(timeNow.getTime() / 1000)) - Number(vehicleDetails.tracking.nextRetryTimestamp));
        minutes = Number(seconds) / 60;
        hours = Number(minutes) / 60;
        days = Number(hours) / 24;
        years = Number(days) / 365;
    }

    //Calculating for finalretrytimestamp.
    if (vehicleDetails && vehicleDetails.tracking&& vehicleDetails.tracking.finalRetryTimestamp) {
        secondsFinal = Math.abs(Number(vehicleDetails.tracking.finalRetryTimestamp) - Number(Math.round(timeNow.getTime() / 1000)));
        minutesFinal = Number(secondsFinal) / 60;
        hoursFinal = Number(minutesFinal) / 60;
        daysFinal = Number(hoursFinal) / 24;
        yearsFinal = Number(daysFinal) / 365;
    }


    return (
        <>
            <RightSideBar
                sideBarName="check-approval"
                rightSideBarOpen={dialogOpen}
                sideBarTitle={vehicleNumber}
                sideBarType="checkApproval"
                // handleSubmit={event => submit(event)}
                sourceLocation={source}
                destinationLocation={destination}
                toggleRightSideBar={onConfirm}
                fromCheckApproval={true}
                splitDesign={true}
            >
                <div>
                    {/* <div className={classes.divBox}>
                        <div className={classes.titleV1}>Truck Info.</div>
                        <div className={classes.mtV2}>
                            {vehicleNumber.map((vnumber, index) => (
                                <span key={index} className={classes.vehicleNumberV1}>{vnumber}</span>
                            ))
                            }
                            {vehicle && vehicle.type && vehicle.type != "Other" &&
                                <>
                                    <span className={classes.bullet}>•</span>
                                    <span className={classes.fwBold}>{vehicle.type}</span>
                                </>
                            }
                            {vehicleBodyType && 
                                <span className={classes.bullet}>•</span>
                            }
                            <span>{vehicleBodyType}</span>
                        </div>
                    </div> */}
                    <div className={classes.divBox}>
                        <div className={classes.titleV1}>Driver Name</div>
                        <div className={classes.mtV2}>
                            <span className={classes.fwBold}>{journey && journey.driver && journey.driver.driverName ? journey.driver.driverName : ""}</span>
                            {journey && journey.driver && journey.driver.driverNumber&&
                                <>
                                    <FiberManualRecord className={classes.sep} />
                                    <span className={classes.fwBold}>{journey.driver.driverNumber}</span>
                                </>
                            }
                        </div>
                    </div>

                    {locationPollingStatus &&
                        <div className={classes.divAccepted}>
                            <div className={classes.divAlign}>
                                <CheckCircleIcon className={classes.doneIcon} />
                                <div className={classes.textV1}>{journey && journey.driver && journey.driver.driverName ? journey.driver.driverName : ""} has Approved</div>
                            </div>
                            <div>
                                <Button className={classes.locationButton} onClick={() => handleGetLocationClick()}>Get Location</Button>
                            </div>
                        </div>
                    }

                    {staticStatus &&
                        <div className={classes.divStatic}>
                            <div><StaticStatusIcon className={classes.iconV1} /></div>
                            <div className={classes.mlV1}>Looks like the driver has not given approval via call/SMS</div>
                            <div>
                                <Button className={classes.retryButton} onClick={() => handleRetryClick()}>
                                    Retry
                                </Button>
                            </div>
                        </div>
                    }

                    {!locationPollingStatus &&
                        <div className={classes.divBox}>
                            <div className={classes.fsV1}>
                                {vehicle && vehicle.tracking && (vehicle.tracking.provider).toUpperCase() != "JIO" &&
                                    <span> {config && config.sim_tracking_config && config.sim_tracking_config.trackingConfirmation && config.sim_tracking_config.trackingConfirmation.nonJio && config.sim_tracking_config.trackingConfirmation.nonJio.messageText ? config.sim_tracking_config.trackingConfirmation.nonJio.messageText.replace('@driver_name', (journey && journey.driver && journey.driver.driverName ? journey.driver.driverName : "")) : ""}  </span>
                                }
                                {vehicle && vehicle.tracking && (vehicle.tracking.provider).toUpperCase() == "JIO" &&
                                    <span> {config && config.sim_tracking_config && config.sim_tracking_config.trackingConfirmation && config.sim_tracking_config.trackingConfirmation.jio && config.sim_tracking_config.trackingConfirmation.jio.messageText ? config.sim_tracking_config.trackingConfirmation.jio.messageText.replace('@driver_name', (journey && journey.driver && journey.driver.driverName ? journey.driver.driverName : "")) : ""}  </span>
                                }
                            </div>
                            <div className={classes.mtV2}>
                                {vehicle && vehicle.tracking && (vehicle.tracking.provider).toUpperCase() != "JIO" &&
                                    <span>
                                        {config && config.sim_tracking_config && config.sim_tracking_config.trackingConfirmation && config.sim_tracking_config.trackingConfirmation.nonJio && config.sim_tracking_config.trackingConfirmation.nonJio.phoneNumber ? (config.sim_tracking_config.trackingConfirmation.nonJio.phoneNumber).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                    </span>
                                }
                                {vehicle && vehicle.tracking && (vehicle.tracking.provider).toUpperCase() == "JIO" &&
                                    <span>
                                        {config && config.sim_tracking_config && config.sim_tracking_config.trackingConfirmation && config.sim_tracking_config.trackingConfirmation.jio && config.sim_tracking_config.trackingConfirmation.jio.phoneNumber ? config.sim_tracking_config.trackingConfirmation.jio.phoneNumber : ""}
                                    </span>
                                }
                            </div>
                        </div>
                    }

                    {consentPendingStatus &&
                        <div className={classes.divBoxV1}>
                            <div>
                                <div className={classes.fwV1}>Checking for driver approval in </div>
                                <div className={classes.titleV2}>{vehicleDetails.tracking&&vehicleDetails.tracking.numberOfRetriesCompleted?vehicleDetails.tracking.numberOfRetriesCompleted:'0'}/{vehicleDetails && vehicleDetails.tracking && vehicleDetails.tracking.totalNumberOfRetries?vehicleDetails.tracking.totalNumberOfRetries:''} attempts failed. Last check in &nbsp;
                                    {vehicleDetails.tracking&&vehicleDetails.tracking.finalRetryTimestamp?`${getDatePickerDateInStringDDMMMYYYY(new Date((Number(vehicleDetails.tracking.finalRetryTimestamp) * 1000)))} ${getTimeInHHMM(Number(vehicleDetails.tracking.finalRetryTimestamp))}`:''}
                                    {/* {hoursFinal < 1 && minutesFinal < 2 && minutesFinal >= 1 &&
                                        <>
                                            <span>{Math.trunc(minutesFinal) + ' min'}</span>
                                        </>
                                    }
                                    {hoursFinal < 1 && minutesFinal >= 2 &&
                                        <>
                                            <span>{Math.trunc(minutesFinal) + ' mins'}</span>
                                        </>
                                    }
                                    {hoursFinal < 1 && minutesFinal < 1 && secondsFinal < 2 && secondsFinal >= 1 &&
                                        <>
                                            <span>{Math.trunc(secondsFinal) + ' sec'}</span>
                                        </>
                                    }
                                    {hoursFinal < 1 && minutesFinal < 1 && secondsFinal >= 2 &&
                                        <>
                                            <span>{Math.trunc(secondsFinal) + ' secs'}</span>
                                        </>
                                    }
                                    {hoursFinal >= 2 &&
                                        <>
                                            <span>{Math.trunc(hoursFinal) + ' hrs'}</span>
                                        </>
                                    }
                                    {hoursFinal >= 1 && hoursFinal < 2 &&
                                        <>
                                            <span>{Math.trunc(hoursFinal) + ' hr'}</span>
                                        </>
                                    } */}
                                </div>
                            </div>
                            {vehicleDetails && vehicleDetails.tracking 
                            && vehicleDetails.tracking.finalRetryTimestamp && 
                            new Date(Number(vehicleDetails.tracking.finalRetryTimestamp)*1000)>new Date()&&
                            <div className={classes.divTimer}>
                                <div className={classes.mrV1}><TimerIcon className={classes.iconV2} /></div>
                                <div className={classes.divTimerV1}>
                                    <Timer
                                        initialTime={seconds * 1000}
                                        direction="backward"
                                        checkpoints={[
                                            {
                                                time: 0,
                                                callback: () => handleTimerStop(),
                                            }
                                        ]}
                                    >
                                        {({ getTime }) => (
                                            <React.Fragment>
                                                {hours < 1 && minutes < 2 &&
                                                    <>
                                                        <Timer.Minutes /> min
                                                    </>
                                                }
                                                {hours < 1 && minutes >= 2 &&
                                                    // <>
                                                    //     <Timer.Minutes /> mins
                                                    // </>
                                                    <>
                                                        {(getTime() < 60000) ?
                                                            <>
                                                                <Timer.Seconds />&nbsp;secs
                                                            </>
                                                            :
                                                            <>
                                                                <Timer.Minutes />&nbsp;
                                                                {(getTime() < 120000) ?
                                                                    'min' : 'mins'
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                                {hours < 1 && minutes < 1 && seconds < 2 &&
                                                    <>
                                                        <Timer.Seconds /> sec
                                                    </>
                                                }
                                                {hours < 1 && minutes < 1 && seconds >= 2 &&
                                                    <>
                                                        <Timer.Seconds /> secs
                                                    </>
                                                }
                                                {hours >= 2 &&
                                                    <>
                                                        <Timer.Hours /> hrs
                                                    </>
                                                }
                                                {hours >= 1 && hours < 2 &&
                                                    <>
                                                        <Timer.Hours /> hr
                                                    </>
                                                }
                                            </React.Fragment>
                                        )}
                                    </Timer>
                                </div>
                            </div>}
                        </div>
                    }
                </div>

                <div className={classes.divV1}>
                    <div className={classes.mtV1}>
                        <div>Disclaimer : SMS approval may take upto 15 minutes. Its</div>
                        <div>depends on network coverage.</div>
                    </div>

                    <div className={classes.mtV1}>
                        <div>We follow all privacy guidelines to protect your data with</div>
                        <div>100% security. For more information, please contact us at</div>
                        <div className={classes.colorV1}>hello@transportbook.in</div>
                    </div>

                    <div className={classes.divV3}>
                        <HttpsIcon className={classes.colorV2} />
                        <div>100% Secure</div>
                        <div className={classes.bulletV1}>•</div>
                        <div>256 -bit encryption</div>
                    </div>
                </div>

            </RightSideBar>
        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchSimTracking: (data, onSuccess, onFailure) => {
        dispatch(simTrackingRegister(data, onSuccess, onFailure))
    },
    dispatchTripDetailsAction: (tripId, onSuccess, onError) => {
        dispatch(getJourneyDetails(tripId, onSuccess, onError))
    },
    dispatchGetSimTrackingLocation: (tripId, onSuccess, onFailure) => {
        dispatch(getLocationForSimTracking(tripId, onSuccess, onFailure))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckApprovalDialog);